/**
 * The hub: standing on it opens its card and its beacon (the world's QR code over the pad), close
 * up, as does its button there (game/options). Walking onto it opens them; arriving on it doesn't,
 * as everyone does; walking off closes them, as for every panel about a tile (panels.ts). The card
 * leaves the planet free to turn. When they close, the view goes back to the zoom it had before.
 */
import { KIND } from '@bramvasterd/terrella-rules';

import type { Game } from '../game';
import { openPanel, setOverview, setViewTarget } from './panels';

/** The zoom a game had when its hub opened, to go back to when the hub closes. */
const zoomBefore = new WeakMap<Game, number>();

export function openHub(game: Game): void {
  const s = game.store.get();
  if (s.panel !== 'hub') zoomBefore.set(game, game.local.viewTarget);
  setOverview(game, false);
  openPanel(game, 'hub', s.here);
}

export function startHubCard(game: Game): () => void {
  return game.store.subscribe((s, prev) => {
    const sameWorld = s.world?.id === prev.world?.id;
    if (prev.panel === 'hub' && s.panel !== 'hub') {
      // closed by walking off, its close button or Escape: back to the zoom from before; another
      // world starts close up
      const zoom = zoomBefore.get(game);
      zoomBefore.delete(game);
      if (zoom !== undefined && sameWorld) setViewTarget(game, zoom);
    }
    if (s.here === prev.here || s.here < 0 || !s.view || !sameWorld) return;
    if (s.view.kind[s.here] === KIND.HUB && prev.here >= 0 && s.panel === 'none') openHub(game);
  });
}
